import { Container } from '@pixi/react'
import { SwitchSpinTypeTab } from './SwitchSpinTypeTab'
import { SpinType, useBetDetailStore } from '../../../domain/betDetail/store/betDetailStore'
import { memo } from 'react'
import { Button, soundManager, SoundType } from '@slot-nx/core'
import { WinningDetail } from './WinningDetail'
import { betDetailService } from '../../../domain/betDetail/service/BetDetailService'
import { GameDetail as GameDetailModel } from '../../../domain/betDetail/models/BetDetailResponse'
import { TableDetail } from './TableDetail'

interface GameDetailProps {
  gameDetail: GameDetailModel
  selectSpinType: SpinType
  isFromOpBetDetail: boolean
}
export const GameDetailUi = memo((props: GameDetailProps) => {
  const { gameDetail, selectSpinType, isFromOpBetDetail } = props
  const [getCurrentIndex, getHasPrev, getHasNext, getCurrentGameDetail, getTriggerBonusGameDetail] = useBetDetailStore(x => [
    x.getCurrentIndex,
    x.getHasPrev,
    x.getHasNext,
    x.getCurrentDropDetail,
    x.getTriggerBonusGameDetail,
  ])

  const buttonConfirmSound = () => {
    if (!isFromOpBetDetail) {
      soundManager.play(SoundType.buttonConfirm)
    }
  }

  return (
    <Container name="GameDetail">
      <Button
        name="Previous"
        x={60}
        y={625}
        width={60}
        height={166}
        onPress={() => {
          betDetailService.goToPrevious()
          buttonConfirmSound()
        }}
        defaultView="btn_left_normal"
        disabledView="btn_left_unable"
        hoverView="btn_left_hover"
        pressedView="btn_left_click"
        enabled={getHasPrev()}
      />
      <Button
        name="Next"
        x={960}
        y={625}
        width={60}
        height={166}
        onPress={() => {
          betDetailService.goToNext()
          buttonConfirmSound()
        }}
        defaultView="btn_right_normal"
        disabledView="btn_right_unable"
        hoverView="btn_right_hover"
        pressedView="btn_right_click"
        enabled={getHasNext()}
      />

      <SwitchSpinTypeTab spinType={selectSpinType} gameDetail={gameDetail} currentIndex={getCurrentIndex()} isFromOpBetDetail={isFromOpBetDetail} />
      <TableDetail currentGameDetail={getCurrentGameDetail()} triggerGameDetail={getTriggerBonusGameDetail()} spinType={selectSpinType} />
      <WinningDetail currentGameDetail={getCurrentGameDetail()} triggerGameDetail={getTriggerBonusGameDetail()} selectSpinType={selectSpinType} />
    </Container>
  )
})
